import DatePickerRangeSelectField from './datePickerRangeSelectField'
import {connect} from 'react-redux'
import {getRegionalDateFormat, getRegionalLocale} from 'selectors/settings'

const mapStateToProps = (state) => {
  return {
    locale: getRegionalLocale(state),
    dateFormat: getRegionalDateFormat(state),
  }
}

export default connect(mapStateToProps)(DatePickerRangeSelectField)
